<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M12.36 21.99c-.57 0-1.05-.47-1.05-1.05V3.04a1.05 1.05 0 0 1 2.1 0v17.91c0 .58-.47 1.05-1.05 1.05v-.01ZM19.72 12 15.9 9.31v5.35L19.72 12ZM5 12l3.82-2.68v5.35L5 12Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
